
//:style="{ backgroundImage: 'url(' + getIllustrationsPath('14.png') + ')' }"
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { asideTheme, brandLightLogo, brandDarkLogo, } from "@/core/helpers/config";

export default defineComponent({
  name: "auth",
  components: {},
  setup() {
    const store = useStore();
    const version = ref(process.env.VUE_APP_VERSION)
    const terms = ref<any>('')
    const appName = ref(process.env.VUE_APP_NAME)

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
    });

    onUnmounted(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    });

    return {
        appName,
      version,
      terms,
      getIllustrationsPath,
      asideTheme, brandLightLogo, brandDarkLogo
    };
  },
});
